import { useRouter } from 'next/router'
import Script from 'next/script'
import { SessionProvider } from 'next-auth/react'
import React, { useEffect } from 'react'
import TagManager from 'react-gtm-module'
import { ParallaxProvider } from 'react-scroll-parallax'

import { Auth } from '@components/Auth'
import { Footer } from '@components/Footer'
import { GlobalStyles } from '@components/GlobalStyles'
import { Header } from '@components/Header'
import { UpToScroll } from '@components/UpToScroll'
import * as gtag from '@lib/gtag'
import { theme, ThemeProvider, Container } from '@theme'

function App({ Component, pageProps: { session, ...pageProps } }) {
  const router = useRouter()

  useEffect(() => {
    if (gtag.GA_TRACKING_ID) {
      const handleRouteChange = url => {
        gtag.pageView(url)
      }
      router.events.on('routeChangeComplete', handleRouteChange)
      TagManager.initialize({ gtmId: gtag.GA_TAG_MANAGER })
      return () => {
        router.events.off('routeChangeComplete', handleRouteChange)
      }
    }
  }, [router.events])

  return (
    <SessionProvider session={session}>
      <ThemeProvider theme={theme}>
        <ParallaxProvider>
          <Header />
          <Container>
            {Component.auth ? (
              <Auth {...Component.auth}>
                <Component {...pageProps} />
              </Auth>
            ) : (
              <Component {...pageProps} />
            )}
            <UpToScroll />
          </Container>
          <Footer />
        </ParallaxProvider>
        <GlobalStyles />
      </ThemeProvider>
      {gtag.GA_TRACKING_ID && (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${gtag.GA_TRACKING_ID}`}
            strategy="afterInteractive"
          />
          <Script
            data-ad-client={`ca-pub-${gtag.GA_GOOGLE_ADS_ID}`}
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
          />
          <Script id="google-analytics" strategy="afterInteractive">
            {`
                  window.dataLayer = window.dataLayer || [];
                  function gtag(){dataLayer.push(arguments);}
                  gtag('js', new Date());
                  gtag('config', '${gtag.GA_TRACKING_ID}', {
                    page_path: window.location.pathname,
                  });
                `}
          </Script>
        </>
      )}
    </SessionProvider>
  )
}

export default App
